/* --------------------------------------------------
Selectors
-------------------------------------------------- */

// Load the styles
window.LoadCSS('/_resources/themes/marmalade/dist/styles/selects.css');

// Create an object to store all the selectors
window.SimpleSelectors = {};

// Create a variable to check if the script has loaded
let loaded = false;
// Create a variable to store the SimpleSelector class
let SimpleSelector = null;

// Create a function to initialise the selectors
function init() {
  let selects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Loop through the selects
  selects.forEach(select => {
    // Create a new SimpleSelector
    const Selector = new SimpleSelector(select);
    // Add the selector to the SimpleSelectors object
    select.SimpleSelector = Selector;
    window.SimpleSelectors[select.id] = Selector;

    // Try add the jQuery change event
    try {
      let $select = $(select);
      Selector.on('change', () => {
        if (!$select) $select = $(select);
        $select.trigger('change');
      });
    } catch (err) {}
  });
}

// Create a function to observe for new selects
DomObserver.observe('select', selects => {
  // If the script has not loaded
  if (!loaded) {
    Promise.all([import('simple-selector')]).then(_ref => {
      let [moduleSimpleSelector] = _ref;
      // Set the script as loaded
      loaded = true;
      // Get the SimpleSelector class
      SimpleSelector = moduleSimpleSelector.default;
      // Initialise the selectors
      init(selects);
    }).catch(error => {
      console.error('An error occurred while loading the modules:', error);
    });
  }

  // If the script has loaded
  else init(selects);
});